import React, { useState } from "react";
import CustomButton from "../CustomButton";
import ModalUI from "../ui/ModalUI";

const ReminderModal = ({ show, onHide, onSave, defaultDateTime }) => {
  const options = [
    { label: "1 month before", value: '30' },
    { label: "2 weeks before", value: '14' },
    { label: "1 week before", value: '7' },
    { label: "1 day before", value: '1' },
    { label: "Custom...", value: "custom" }
  ];

  const [selectedOption, setSelectedOption] = useState(null);
  const [customDateTime, setCustomDateTime] = useState(defaultDateTime || "");

  const handleSave = () => {
    if (selectedOption === "custom" && customDateTime) {
      onSave({ type: "custom", value: customDateTime });
    } else if (selectedOption && selectedOption !== "custom") {
      onSave({ type: selectedOption }); // type is integer, no value
    }
    onHide();
  };

  const getButtonStyle = (value) => ({
    padding: "8px 16px",
    borderRadius: "50px",
    border: selectedOption === value ? "2px solid #1081fa" : "1px solid #ccc",
    backgroundColor: selectedOption === value ? "#f5f6f7" : "#fff",
    cursor: "pointer",
  });

  return (
    <ModalUI
      show={show}
      handleClose={onHide}
      title="Set Reminder for Submission Deadline"
      titleClass="fw-bold"
      size="md"
    >
      <p className="text-muted mb-4">
        We'll notify you before the submission deadline approaches
      </p>

      <div className="d-flex flex-wrap gap-2 mb-4">
        {options.map((opt, index) => (
          <button
            key={index}
            style={getButtonStyle(opt.value)}
            onClick={() => setSelectedOption(opt.value)}
          >
            {opt.label}
          </button>
        ))}
      </div>

      {selectedOption === "custom" && (
        <div className="mb-4">
          <label className="form-label">Select date for your reminder:</label>
          <input
            type="date"
            className="form-control"
            value={customDateTime}
            onChange={e => setCustomDateTime(e.target.value)}
          />
        </div>
      )}

      <div className="d-flex justify-content-end gap-2">
        <CustomButton variant="outline" onClick={onHide}>
          Close
        </CustomButton>
        <CustomButton onClick={handleSave} disabled={!selectedOption || (selectedOption === "custom" && !customDateTime)}>
          Save
        </CustomButton>
      </div>
    </ModalUI>
  );
};

export default ReminderModal;
